import { createGlobalStyle } from 'styled-components';

import MerriweatherBlack from '@/assets/fonts/merriweather-black.woff';

const VariationStyles = createGlobalStyle`
  @font-face {
    font-family: 'MerriweatherBlack';
    src: url(${MerriweatherBlack});
    font-weight: 900;
    font-style: normal;
  }

  .generated-images-holder-var11 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1080px;
  }
  .image-holder-var11 {
    width: 100%;
    position: relative;
    height: 1350px;
    display: flex;
    flex-direction: column;
    background-color: #cd2620;
    padding: 23px 0 29px;
    border: 1px solid #e3e3e3;
  }

  .watermark-box {
    background-color: black;
    flex: 1%;
    width: 100%;
    display: flex;
    align-items: center;
    padding-left: 40px;
  }
 
  .bottom-text-var11 {
    font-size: 45px;
    line-height: 1.25;
    color: #000000;
    font-family: MerriweatherBlack;
    z-index: 1;
    display: flex;
    align-items: center;
    height: 495px;
    padding: 0 54px;
    background-color: #fff;
    p {
      display: inline-block;
      margin: 0;
      padding: 0;
      text-transform: uppercase;
    }
  }
  .image-wrap-var11 {
    position: relative;
    display: flex;
    width: 100%;
  }

  .full-image-var11 {
    width: 100%;
    height: 710px;
    object-fit: cover;
    position: relative;
  }

  .circle-image-var11 {
    object-fit: cover;
    border-radius: 50%;
    border: solid 10px white;
    width: 450px;
    height: 450px;
    position: absolute;
    top: 433px;
    right: 44px;
    z-index: 2;
  }

  .breaking-news-var-11 {
    position: absolute;
    top: 53px;
    left: 0;
    right: 0;
    margin: auto;
  }
  .actual-photo-var11 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .actual-photo-var11--top {
    top: 0;
    bottom: auto;
  }
  /* the breaking news badge ends 120px down inside the photo */
  .actual-photo-var11--top.actual-photo-var11--breaking-news {
    top: 130px;
  }
`;

export default VariationStyles;
